<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="10">
                    <input type="text" v-model="searchValue" placeholder="Nama Perusahaan" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <h2 class="font-weight-bold mt-2 mb-3">Data Perusahaan</h2>
                <CRow>
                    <CCol sm="6">
                        <label>Nama Perusahaaan</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.companyName.$model"
                            :class="{ 'is-invalid':$v.companyName.$error, 'is-valid': !$v.companyName.$invalid }"
                            placeholder="Nama Perusahaan" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Unit Level</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.unitLevel.$model"
                            :class="{ 'is-invalid':$v.unitLevel.$error, 'is-valid': !$v.unitLevel.$invalid }"
                            placeholder="Unit Level" 
                            type="number"
                            min="1"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Email Perusahaaan</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.email.$model"
                            :class="{ 'is-invalid':$v.email.$error, 'is-valid': !$v.email.$invalid }"
                            placeholder="Email Perusahaan" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nomor Telp Perusahaan</label>
                        <input 
                            class="form-control" 
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            v-model.trim="$v.telp.$model"
                            :class="{ 'is-invalid':$v.telp.$error, 'is-valid': !$v.telp.$invalid }"
                            placeholder="No. Tlp Perusahaaan" 
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Alamat Perusahaan</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.alamat.$model"
                            :class="{ 'is-invalid':$v.alamat.$error, 'is-valid': !$v.alamat.$invalid }"
                            placeholder="Alamat" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Penyedia Jasa Tenaga Kerja (PJTK)</label>
                        <model-select :options="dataPJTK"
                            class="form-control model-select"
                            v-model.trim="$v.pjtk.$model"
                            :class="{ 'is-invalid select-invalid':$v.pjtk.$error, 'is-valid select-valid': !$v.pjtk.$invalid }"
                            placeholder="Pilih PJTK">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nomor Pokok Wajib Pajak (NPWP)</label>
                        <input 
                            class="form-control" 
                            v-model="npwp"
                            placeholder="NPWP" 
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                            type="text"
                        />
                    </CCol>
                    <CCol v-if="pjtk.value == 'Y'" sm="6">
                        <label>Penyedia Jasa Tenaga Kerja untuk :</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    @click="toggleVisiblePerusahaan()"
                                    @blur="toggleCloseVisiblePerusahaan()"
                                    v-text="selectedItemPerusahaan ? selectedItemPerusahaan['text'] : ''"
                                    v-model="queryPerusahaan"
                                    @keydown.up="upPerusahaan"
                                    @keydown.down="downPerusahaan"
                                    @keydown.enter="selectItemPerusahaan"
                                    placeholder="Pilih Perusahaan"
                            >
                            <div class="popovers" v-show="visiblePerusahaan">
                                <div class="options" v-if="matchesPerusahaan.length != 0 && queryPerusahaan.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesPerusahaan"
                                        :key="index"
                                        :class="{ 'selected': (selectedPerusahaan == index)}"
                                        @click="itemClickedPerusahaan(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesPerusahaan.length == 0 && queryPerusahaan.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesPerusahaan.length == 0 && queryPerusahaan.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
                <CRow class="mb-4" v-if="tempPerusahaan.length != 0">
                    <CCol sm="6"></CCol>
                    <CCol sm="6">
                        <CRow v-for="(li, id) in tempPerusahaan" :key="id">
                            <CCol sm="11">
                                -  {{li.nama}}
                            </CCol>
                            <CCol sm="1">
                                <span @click="deletePerusahaan(id)" title="Hapus" style="cursor:pointer">x</span>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <hr/>
                <CRow class="mt-2">
                    <CCol v-if="tipe == 'U' || tipe == 'u'" sm="6">
                        <label>Kode Perusahaan</label>
                        <input 
                            class="form-control "
                            style="background-color:whitesmoke"
                            disabled
                            v-model="codeCompany"
                            placeholder="Kode Perusahaan"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Email Penanggung Jawab (PIC)</label>
                        <input 
                            class="form-control" 
                            placeholder="Email PIC"
                            v-model.trim="$v.emailPIC.$model"
                            :class="{ 'is-invalid':$v.emailPIC.$error, 'is-valid': !$v.emailPIC.$invalid }"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nomor Handphone Penanggung Jawab (PIC)</label>
                        <input 
                            class="form-control" 
                            placeholder="No. HP PIC"
                            v-model.trim="$v.noHp.$model"
                            :class="{ 'is-invalid':$v.noHp.$error, 'is-valid': !$v.noHp.$invalid }"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Segmen Perusahaan</label>
                        <model-select :options="dataSegmen"
                            class="form-control model-select"
                            v-model.trim="$v.segmen.$model"
                            :class="{ 'is-invalid select-invalid':$v.segmen.$error, 'is-valid select-valid': !$v.segmen.$invalid }"
                            placeholder="Pilih Segmen Perusahaan">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Expired Date</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.expiredDate.$model"
                            :class="{ 'is-invalid':$v.expiredDate.$error, 'is-valid': !$v.expiredDate.$invalid }"
                            type="date"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Maksimal Jumlah Pegawai</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.maxPegawai.$model"
                            :class="{ 'is-invalid':$v.maxPegawai.$error, 'is-valid': !$v.maxPegawai.$invalid }"
                            placeholder="Maks Pegawai" 
                            type="number"
                            min="1"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Waktu Sync Offline</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.timeSync.$model"
                            :class="{ 'is-invalid':$v.timeSync.$error, 'is-valid': !$v.timeSync.$invalid }"
                            type="time"
                        />
                    </CCol>
                </CRow>
                <CRow style="margin-bottom:64px">
                    <CCol sm="6">
                        <label>Logo Perusahaan</label>
                        <div v-if="urlImage == '' || urlImage == 'null'">
                            <input v-on:change="onFileChange" style="position:absolute;opacity:0;z-index:1;cursor:pointer" type="file" class="mr-2" accept=".jpg, .png, .bmp" />
                            <div class="cards-image">+</div>
                        </div>
                        <div v-else>
                            <img :src="urlImage" width="56" height="56" />
                            <button @click="removeImage()" class="ml-3 btn btn-danger" size="sm">Delete</button>
                        </div>
                    </CCol>
                </CRow>
                <h2 class="font-weight-bold mt-5 mb-3">Data Kantor Pusat</h2>
                <CRow>
                    <CCol sm="6">
                        <label>Nama Kantor</label>
                        <input 
                            class="form-control mr-2" 
                            v-model.trim="$v.namaKantor.$model"
                            :class="{ 'is-invalid':$v.namaKantor.$error, 'is-valid': !$v.namaKantor.$invalid }"
                            placeholder="Nama Kantor" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Provinsi</label>
                        <div class="autocomplete">
                            <input type="text"
                                    :class="{ 'is-invalid':$v.queryProvinsi.$error, 'is-valid': !$v.queryProvinsi.$invalid }"
                                    class="form-control"
                                    @click="toggleVisibleProvinsi()"
                                    @blur="toggleCloseVisibleProvinsi()"
                                    v-text="selectedItemProvinsi ? selectedItemProvinsi['text'] : ''"
                                    v-model.trim="$v.queryProvinsi.$model"
                                    @keydown.up="upProvinsi"
                                    @keydown.down="downProvinsi"
                                    @keydown.enter="selectItemProvinsi"
                                    placeholder="Pilih Provinsi"
                            >
                            <div class="popovers" v-show="visibleProvinsi">
                                <div class="options" v-if="matchesProvinsi.length != 0 && queryProvinsi.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesProvinsi"
                                        :key="index"
                                        :class="{ 'selected': (selectedProvinsi == index)}"
                                        @click="itemClickedProvinsi(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesProvinsi.length == 0 && queryProvinsi.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesProvinsi.length == 0 && queryProvinsi.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Alamat Kantor</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.alamatKantor.$model"
                            :class="{ 'is-invalid':$v.alamatKantor.$error, 'is-valid': !$v.alamatKantor.$invalid }"
                            placeholder="Alamat"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Kabupaten/Kota</label>
                        <div class="autocomplete">
                            <input type="text"
                                    :class="{ 'is-invalid':$v.queryKota.$error, 'is-valid': !$v.queryKota.$invalid }"
                                    class="form-control"
                                    @click="toggleVisibleKota()"
                                    @blur="toggleCloseVisibleKota()"
                                    v-text="selectedItemKota ? selectedItemKota['text'] : ''"
                                    v-model.trim="$v.queryKota.$model"
                                    @keydown.up="upKota"
                                    @keydown.down="downKota"
                                    @keydown.enter="selectItemKota"
                                    placeholder="Pilih Kota"
                            >
                            <div class="popovers" v-show="visibleKota">
                                <div class="options" v-if="matchesKota.length != 0 && queryKota.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesKota"
                                        :key="index"
                                        :class="{ 'selected': (selectedKota == index)}"
                                        @click="itemClickedKota(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesKota.length == 0 && queryKota.length == 0 && queryProvinsi.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in dataKota"
                                        :key="index"
                                        :class="{ 'selected': (selectedKota == index)}"
                                        @click="itemClickedKotaBefore(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesKota.length == 0 && queryKota.length != 0 && queryProvinsi.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesKota.length == 0 && queryProvinsi.length == 0">
                                    Pilih Provinsi Dahulu
                                </div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Latitude</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.latitude.$model"
                            :class="{ 'is-invalid':$v.latitude.$error, 'is-valid': !$v.latitude.$invalid }"
                            placeholder="Latitude"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Longitude</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.longitude.$model"
                            :class="{ 'is-invalid':$v.longitude.$error, 'is-valid': !$v.longitude.$invalid }"
                            placeholder="Longitude"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Radius (meter)</label>
                        <input 
                            class="form-control" 
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            v-model.trim="$v.radius.$model"
                            :class="{ 'is-invalid':$v.radius.$error, 'is-valid': !$v.radius.$invalid }"
                            placeholder="Radius" 
                            type="text"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tables'
import { DataApi, DataApiUpload } from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required, email, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
    components: {
        Tables,
        ModelSelect
    },
    mixins: [validationMixin],
    validations: {
        latitude: {
            required: (function() {
                if(this.valueValidateLat == true) {
                    return true
                } else {
                    return false
                }
            })
        },
        longitude: {
            required: (function() {
                if(this.valueValidateLong == true) {
                    return true
                } else {
                    return false
                }
            })
        },
        companyName: {
            required
        },
        timeSync: {
            required
        },
        emailPIC: {
            required,
            email,
            maxLength: maxLength(50)
        },
        email: {
            required,
            email,
            maxLength: maxLength(50)
        },
        unitLevel: {
            required
        },
        maxPegawai: {
            required
        },
        expiredDate: {
            required
        },
        alamat: {
            required
        },
        pjtk: {
            value: {
                required
            },
            text: {
                required
            }
        },
        segmen: {
            value: {
                required
            },
            text: {
                required
            }
        },
        noHp: {
            required
        },
        telp: {
            required
        },
        queryProvinsi: {
            required
        },
        queryKota: {
            required
        },
        alamatKantor: {
            required
        },
        radius: {
            required
        },
        namaKantor: {
            required
        },
    },
    data() {
        return {
            success: true,
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            dataTh: ['Nama Perusahaan', 'Kode', 'Unit Level', 'Expired Date', 'Action'],
            dataTd: ['nama', 'kode', 'unitLevel', 'tglExpired', 'action'],
            styleTable: ['275px', '110px', '200px', '150px', '150px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            companyName: '',
            emailPIC: '',
            email: '',
            telp: '',
            alamat: '',
            dataPJTK: [],
            pjtk: {
                value: '',
                text: ''
            },
            urlImage: '',
            showImage: '',
            urlPath: '',
            codeCompany: '',
            unitLevel: '',
            maxPegawai: '',
            expiredDate: '',
            timeSync: '',
            tipe: 'C',
            selectedPerusahaan: {
                value: '',
                text: ''
            },
            dataSegmen: [],
            segmen: {
                value: '',
                text: ''
            },
            noHp: '',


            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchValue: '',

            namaKantor: '',
            alamatKantor: '',
            radius: '',
            latitude: '',
            longitude: '',

            titleProvinsi:"Pilih Provinsi",
            selectedItemProvinsi: null,
            selectedProvinsi: 0,
            queryProvinsi: '',
            visibleProvinsi: false,

            titleKota:"Pilih Kota",
            selectedItemKota: null,
            selectedKota: 0,
            queryKota: '',
            visibleKota: false,

            // data perusahaan
            dataPerusahaan: [],
            titlePerusahaan:"Pilih Perusahaan",
            selectedItemPerusahaan: null,
            selectedPerusahaan: 0,
            queryPerusahaan: '',
            visiblePerusahaan: false,
            idPerusahaan: '',

            tempPerusahaan: [],
            npwp: '',

            valueValidateLong: false,
            valueValidateLat: false,
            
            // datas
            datas: [],

            organisasi: '',
            lvl: '',

            //error
            errorMessage: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchValue() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryProvinsi() {
            this.getProvince()
            this.dataKota = []
            if(this.tipe == 'C') {
                this.queryKota = ''
            }
        },
        queryPerusahaan() {
            if(this.queryPerusahaan == '') {
                this.idPerusahaan = ''
            }
            this.getDataPerusahaan()
        },
        latitude() {
            this.validationLat()
        },
        longitude() {
            this.validationLong()
        },
        queryKota() {
            this.getCity('null')
        },
    },
    methods: {
        /**
         * SEARCH UNIT LEVEL
         */
         getDataPerusahaan() {
            let payload = {
                limit: 10,
                namaOrganisasi: this.queryPerusahaan,
                organisasi: '',
                pageIn: 1,
            }
            DataApi.post("perusahaan/get", payload)
            .then(res => {
                this.dataPerusahaan = []
                let response = res.data.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].kode,
                        text: tempData[i].nama
                    }
                    this.dataPerusahaan.push(onPush)
                }
            })
        },
        toggleVisiblePerusahaan() {
            this.visiblePerusahaan = true;
        },
        hidePerusahaan() {
            this.visiblePerusahaan = false;
        },
        toggleCloseVisiblePerusahaan() {
            setTimeout(this.hidePerusahaan, 1000);
        },
        itemClickedPerusahaan(index) {
            this.selectedPerusahaan = index;
            this.selectItemPerusahaan();
        },
        selectItemPerusahaan() {
            if (!this.matchesPerusahaan.length) {
            return;
            }
            this.selectedItemPerusahaan = this.matchesPerusahaan[this.selectedPerusahaan];
            
            let ol = this.tempPerusahaan
            if(ol.length == 0) {
                let onPush = {
                    id: this.selectedItemPerusahaan.value,
                    nama: this.selectedItemPerusahaan.text
                }
                this.tempPerusahaan.push(onPush)
            } else {
                var i = 0
                let status = false
                for(i=0;i<ol.length;i++) {
                    if(ol[i].id == this.selectedItemPerusahaan.value) {
                        status = true
                        break
                    } else {
                        status = false
                    }
                }
                if(status == false) {
                    let onPush = {
                        id: this.selectedItemPerusahaan.value,
                        nama: this.selectedItemPerusahaan.text
                    }
                    this.tempPerusahaan.push(onPush)
                }
            }
            this.queryPerusahaan = ''
            this.idPerusahaan = ''
            this.visiblePerusahaan = false;
            if (this.shouldReset) {
            this.queryPerusahaan = '';
            this.selectedPerusahaan = 0;
            }
        },
        deletePerusahaan(val) {
            this.tempPerusahaan.splice(val,1)
        },
        upPerusahaan() {
            if (this.selectedPerusahaan == 0) {
            return;
            }
            this.selectedPerusahaan -= 1;
            this.scrollToItemPerusahaan();
        },
        downPerusahaan() {
            if (this.selectedPerusahaan >= this.matchesPerusahaan.length - 1) {
            return;
            }
            this.selectedPerusahaan += 1;
            this.scrollToItemPerusahaan();
        },
        scrollToItemPerusahaan() {
            this.$refs.optionsList.scrollTop = this.selectedPerusahaan * this.itemHeight;
        },

        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.kode.toLowerCase() < b.kode.toLowerCase()) {
                        return -1
                    }
                    if (a.kode.toLowerCase() > b.kode.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.unitLevel.toLowerCase() < b.unitLevel.toLowerCase()) {
                        return -1
                    }
                    if (a.unitLevel.toLowerCase() > b.unitLevel.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.tglExpired.toLowerCase() < b.tglExpired.toLowerCase()) {
                        return -1
                    }
                    if (a.tglExpired.toLowerCase() > b.tglExpired.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let namaOrganisasi = this.searchValue
            let organisasi = this.searchOrganization
            let page = this.page

            let payload = {
                limit: limit,
                namaOrganisasi: namaOrganisasi,
                organisasi: organisasi,
                pageIn: page,
            }
            DataApi.post("perusahaan/get", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.searchValue = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.tempPerusahaan = []
                this.queryPerusahaan = ''
                this.idPerusahaan = ''
                this.npwp = ''
                this.segmen.value = ''
                this.segmen.text = ''
                this.noHp = ''
                this.unitLevel = ''
                this.maxPegawai = ''
                this.codeCompany = ''
                this.alamat = ''
                this.pjtk.value = ''
                this.pjtk.text = ''
                this.emailPIC = ''
                this.email = ''
                this.telp = ''
                this.urlImage = ''
                this.showImage = ''
                this.urlPath = ''
                this.expiredDate = ''
                this.companyName = ''
                this.alamatKantor = ''
                this.radius = ''
                this.namaKantor = ''
                this.latitude = ''
                this.longitude = ''
                this.queryProvinsi = ''
                this.timeSync = ''
                this.queryKota = ''
                this.tipe = 'C'
                this.getDataSegmen()
                this.getDataPjtk()
                this.getProvince()
                this.$v.$reset()
            }
        },
        goSave() {
            this.$store.state.loadingScreen = true
            let pjtkTo = []
            var i = 0
            let li = this.tempPerusahaan
            for(i=0;i<li.length;i++) {
                pjtkTo.push(li[i].id)
            }
            let namaOrganisasi = this.companyName
            let unitLevel = this.unitLevel
            let expiredDate = this.expiredDate
            let organisasi = this.codeCompany
            let emailPic = this.emailPIC
            let tipe = this.tipe
            let maxPegawai = this.maxPegawai
            let alamat = this.alamat
            let email = this.email
            let logo = this.urlPath
            let pjtk = this.pjtk.value
            let segmen = this.segmen.value
            let noHp = this.noHp
            let telp = this.telp

            let alamatKantor = this.alamatKantor
            let kotaKantor = this.queryKota
            let provinsiKantor = this.queryProvinsi
            let radius = this.radius
            let nama = this.namaKantor
            let latitude = this.latitude
            let longitude = this.longitude
            let zona = ''
            let foto = ''
            let sync = this.timeSync
            let hour = sync.split(":")[0]
            let minute = sync.split(":")[1]

            let payload ={
                alamat: alamat,
                email: email,
                emailPic: emailPic,
                logo: logo,
                maxPegawai: maxPegawai,
                namaOrganisasi: namaOrganisasi,
                npwp: this.npwp,
                pjtkTo: pjtkTo,
                pjtk: pjtk,
                telepon: telp,
                teleponPic: noHp,
                kodeSegmen: segmen,
                tglExpired: expiredDate,
                organisasi: organisasi,
                tipe: tipe,
                unitLevel: unitLevel,
                alamatKantor: alamatKantor,
                kotaKantor: kotaKantor,
                provinsiKantor: provinsiKantor,
                radiusKantor: radius,
                namaKantor: nama,
                lattitudeKantor: latitude,
                longitudeKantor: longitude,
                syncOfflineHour: hour,
                syncOfflineMinute: minute,
                zonaKantor: zona,
                fotoKantor: foto
            }
            DataApi.post("perusahaan/save", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
                this.$store.state.loadingScreen = false
            })
        },
        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.maxPegawai = generate.maxPegawai
            this.unitLevel = generate.unitLevel
            this.codeCompany = generate.kode
            this.expiredDate = generate.tglExpired
            this.companyName = generate.nama
            this.alamat = generate.alamat
            this.email = generate.email
            this.emailPIC = generate.emailPIC
            this.telp = generate.telepon
            let hour = generate.syncOfflineHour
            let minute = generate.syncOfflineMinute

            if(hour == '' && minute == '') {
                this.timeSync = ''
            } else {
                this.timeSync = hour + ':' + minute
            }


            if(generate.listKantorPusat.length != 0) {
                let list = generate.listKantorPusat[0]

                this.alamatKantor = list.alamat
                this.radius = list.radius
                this.latitude = list.lattitude
                this.longitude = list.longitude
                this.namaKantor = list.nama
                this.queryProvinsi = list.provinsi
                this.getCity(list.kota)
            }

            if(generate.logo == 'null' ||
                generate.logo == null ||
                generate.logo == '' ||
                generate.logo == undefined) {
                this.urlImage = 'null'
            } else {
                this.urlImage = generate.logo
            }
            let dataPjtk = this.dataPJTK
            let pjtk = generate.pjtk
            var i 
            for(i=0;i<dataPjtk.length;i++) {
                if(pjtk == dataPjtk[i].value) {
                    this.pjtk.value = dataPjtk[i].value
                    this.pjtk.text = dataPjtk[i].text
                }
            }
            let dataSegmen = this.dataSegmen
            let kodeSegmen = generate.kodeSegmen
            var j
            for(j=0;j<dataSegmen.length;j++) {
                if(kodeSegmen == dataSegmen[j].value) {
                    this.segmen.value = dataSegmen[j].value
                    this.segmen.text = dataSegmen[j].text
                }
            }
            this.noHp = generate.teleponPic
            var li = 0
            let dataPerus = generate.pjtkTo
            for(li=0;li<dataPerus.length;li++) {
                let onPush = {
                    id: dataPerus[li].id,
                    nama: dataPerus[li].nama
                }
                this.tempPerusahaan.push(onPush)
            }
            this.npwp = generate.npwp
            this.tipe = 'u'
            this.moving()
        },

        /**
         * VALIDATION DATA
         */
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.saveImage()
                this.loading = true
            }
        },
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.showImage = files[0];
            this.createImage(files[0]);
        },
        createImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.urlImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        saveImage() {
            if (this.urlImage.split(":")[0] == 'data' && this.urlImage != '') {
                let imageData = this.showImage
                let idPegawaiData = 0
                let inOutData = "1"
                let kodePerusahaanData = this.organisasi
                let tanggalData = new Date()
                let lvlData = this.lvl

                const fd = new FormData()
                fd.append('file', imageData)
                fd.append('idPegawai', idPegawaiData)
                fd.append('inOut', inOutData)
                fd.append('kodePerusahaan', kodePerusahaanData)
                fd.append('tanggal', tanggalData)
                fd.append('lvl', lvlData)

                DataApiUpload.post('upload/file', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlPath = response.data.urlPath
                        this.goSave()
                    } else {
                        alert('Upload Photo Failed !')
                        this.loading = false
                    }
                });
            } else if(this.urlImage == '') {
                this.urlPath = ''
                this.goSave()
            } else {
                this.urlPath = this.urlImage
                this.goSave()
            }
        },
        removeImage() {
            this.showImage = ''
            this.urlImage = ''
            this.urlPath = ''
        },

        validates(e) {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if(/^[A-Za-z]+$/.test(char)) return true; // Match with regex 
            else e.preventDefault(); // If not match, don't add to input text
        },
        getDataPjtk() {
            this.dataPJTK = [
                { value: 'Y', text: 'Yes' },
                { value: 'N', text: 'No'}
            ]
        },
        getProvince() {
            let payload = {
                provinsi: this.queryProvinsi
            }
            DataApi.post("kantor/get/provinsi", payload)
            .then(res => {
                this.dataProvinsi = []
                let response = res.data.data
                var i;
                for(i=0;i<response.length;i++) {
                    let values = {
                        value: response[i],
                        text: response[i]
                    }
                    this.dataProvinsi.push(values)
                }
            })
        },
        getCity(val) {
            if(val == 'null') {
                if(this.queryProvinsi.length == 0) {
                    this.dataKota = []
                } else {
                    let payload = {
                        kabkota: this.queryKota,
                        provinsi: this.queryProvinsi
                    }
                    DataApi.post("kantor/get/kabkota", payload)
                    .then(res => {
                        this.dataKota = []
                        let response = res.data.data
                        var i;
                        for(i=0;i<response.length;i++) {
                            let values = {
                                value: response[i].kabkota,
                                text: response[i].kabkota
                            }
                            this.dataKota.push(values)
                        }
                    })
                }
            } else {
                if(this.queryProvinsi.length == 0) {
                    this.dataKota = []
                } else {
                    let payload = {
                        kabkota: val,
                        provinsi: this.queryProvinsi
                    }
                    DataApi.post("kantor/get/kabkota", payload)
                    .then(res => {
                        this.dataKota = []
                        let response = res.data.data
                        var i;
                        for(i=0;i<response.length;i++) {
                            let values = {
                                value: response[i].kabkota,
                                text: response[i].kabkota
                            }
                            this.dataKota.push(values)
                        }
                        this.queryKota = val
                    })
                }
            }
        },
        toggleVisibleProvinsi() {
            this.visibleProvinsi = true;
        },
        hideProvinsi() {
            this.visibleProvinsi = false;
        },
        toggleCloseVisibleProvinsi() {
            setTimeout(this.hideProvinsi, 1000);
        },
        itemClickedProvinsi(index) {
            this.selectedProvinsi = index;
            this.selectItemProvinsi();
        },
        selectItemProvinsi() {
            if (!this.matchesProvinsi.length) {
            return;
            }
            this.selectedItemProvinsi = this.matchesProvinsi[this.selectedProvinsi];
            this.queryProvinsi = this.selectedItemProvinsi.text
            this.getCity('null')
            this.visibleProvinsi = false;
            if (this.shouldReset) {
            this.queryProvinsi = '';
            this.selectedProvinsi = 0;
            }
        },
        upProvinsi() {
            if (this.selectedProvinsi == 0) {
            return;
            }
            this.selectedProvinsi -= 1;
            this.scrollToItemProvinsi();
        },
        downProvinsi() {
            if (this.selectedProvinsi >= this.matchesProvinsi.length - 1) {
            return;
            }
            this.selectedProvinsi += 1;
            this.scrollToItemProvinsi();
        },
        scrollToItemProvinsi() {
            this.$refs.optionsList.scrollTop = this.selectedProvinsi * this.itemHeight;
        },
        
        toggleVisibleKota() {
            this.visibleKota = true;
        },
        hideKota() {
            this.visibleKota = false;
        },
        toggleCloseVisibleKota() {
            setTimeout(this.hideKota, 1000);
        },
        itemClickedKota(index) {
            this.selectedKota = index;
            this.selectItemKota();
        },
        itemClickedKotaBefore(index) {
            this.selectedKota = index;
            this.selectedItemKota = this.dataKota[this.selectedKota];
            this.queryKota = this.selectedItemKota.text
            this.visibleKota = false;
        },
        selectItemKota() {
            if (!this.matchesKota.length) {
            return;
            }
            this.selectedItemKota = this.matchesKota[this.selectedKota];
            this.queryKota = this.selectedItemKota.text
            this.visibleKota = false;
            if (this.shouldReset) {
            this.queryKota = '';
            this.selectedKota = 0;
            }
        },
        upKota() {
            if (this.selectedKota == 0) {
            return;
            }
            this.selectedKota -= 1;
            this.scrollToItemKota();
        },
        downKota() {
            if (this.selectedKota >= this.matchesKota.length - 1) {
            return;
            }
            this.selectedKota += 1;
            this.scrollToItemKota();
        },
        scrollToItemKota() {
            this.$refs.optionsList.scrollTop = this.selectedKota * this.itemHeight;
        },
        validationLat() {
            let reg = /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/
            let check = reg.test(this.latitude)
            if(check == false) {
                this.valueValidateLat = false
            } else {
                this.valueValidateLat = true
            }
        },
        validationLong() {
            let reg = /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/
            let check = reg.test(this.longitude)
            if(check == false) {
                this.valueValidateLong = false
            } else {
                this.valueValidateLong = true
            }
        },
        getDataToken() {
            this.$store.state.loadingScreen = true
            DataApi.get("pegawai/role/cek")
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.lvl = res.data.lvl
                    this.organisasi = res.data.organisasi
                }
                this.$store.state.loadingScreen = false
            })
        },
        getDataSegmen() {
            let payload = {
                limit: 9999,
                pageIn: 1,
                segmen: ""
            }
            DataApi.post("perusahaan/segmen/lihat", payload)
            .then(res => {
                this.dataSegmen = []
                let response = res.data.data.data
                var i;
                for(i=0;i<response.length;i++) {
                    let values = {
                        value: response[i].unix,
                        text: response[i].segmen
                    }
                    this.dataSegmen.push(values)
                }
            })
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataToken()
        this.getProvince()
        this.getDataPjtk()
        this.getDataSegmen()
        this.getDataPerusahaan()
    },
    computed: {
        matchesProvinsi() {
            if (this.queryProvinsi == '') {
                return [];
            }
            return this.dataProvinsi.filter((item) => item['text'].toLowerCase().includes(this.queryProvinsi.toLowerCase()))
        },
        matchesKota() {
            if (this.queryKota == '') {
                return [];
            }
            return this.dataKota.filter((item) => item['text'].toLowerCase().includes(this.queryKota.toLowerCase()))
        },
        matchesPerusahaan() {
            if (this.queryPerusahaan == '') {
                return [];
            }
            return this.dataPerusahaan.filter((item) => item['text'].toLowerCase().includes(this.queryPerusahaan.toLowerCase()))
        },
    },
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.alert-area {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: rgba(48, 107, 221, 1);
    text-align: center;
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>